import React from "react";
import { Stack } from "@mui/material";

import { HubButton } from "../../components";

const buttonProps = {
  variant: "tinyButton",
  color: "neutral",
  sx: { backgroundColor: "hubColors.white" },
  iconProps: { size: 10 },
};
const ShippingFilters = () => {
  return (
    <Stack direction="row" gap="5px">
      <HubButton label="Status" icon="Disc" {...buttonProps} />
      <HubButton label="Due Date" icon="Calendar" {...buttonProps} />
      <HubButton label="Location" icon="MapPin" {...buttonProps} />
      <HubButton label="Purchase Orders" icon="FileText" {...buttonProps} />
    </Stack>
  );
};

export default ShippingFilters;
